/*!
 * main.js
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */

$('.hamburger-btn').on('click', function (e) {
  e.preventDefault();

  $('.header').toggleClass('is-shown');
});

var slidersArray = [];
var cardsSlider = null;

var setCardsSlider = function () {
  $('.hotel-cards-slider').each(function () {
    var ww = $(window).width();
    var isVersionTwo = $('.hotel-cards-slider').hasClass('v2');

    if (ww < 768) {
      var sliderConfig = {
        spaceBetween: 5,
        slidesPerView: isVersionTwo ? 2.25 : 1.0857,
        centeredSlides: true,
        loop: isVersionTwo ? true : false,
        containerModifierClass: 'hotel-cards-slider--',
        wrapperClass: 'hotel-cards-wrapper',
        slideClass: 'hotel-cards-slide',
        slideActiveClass: 'hotel-cards-slide--active',
        slideNextClass: 'hotel-cards-slide--next',
        slidePrevClass: 'hotel-cards-slide--prev',
        pagination: {
          el: '.hotel-cards-slider .slider-pagination--relative',
          bulletClass: 'slider-pagination-bullet--dark',
          bulletActiveClass: 'slider-pagination-bullet--active',
          currentClass: 'slider-pagination-bullet--current',
          hiddenClass: 'slider-pagination-bullet--hidden',
          clickable: true,
        },
      };

      cardsSlider = new Swiper('.hotel-cards-slider', sliderConfig);
    } else cardsSlider != undefined ? cardsSlider.destroy() : '';
  });
};

$('.full-width-slider[slidesoneperviewslide]').each(function () {
  $(this).closest('section').next('.text-slider-container').addClass('reverse');
});

$('.text-slider-container').each(function () {
  $(this).append("<div class='slider-pagination--relative'></div>");

  var sliderConfig = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    effect: 'fade',
    containerModifierClass: 'text-slider--',
    wrapperClass: 'text-slider-wrapper',
    slideClass: 'text-slider-slide',
    slideActiveClass: 'text-slider-slide--active',
    slideNextClass: 'text-slider-slide--next',
    slidePrevClass: 'text-slider-slide--prev',
    pagination: {
      el: $(this).find('.slider-pagination--relative'),
      bulletClass: 'slider-pagination-bullet--dark',
      bulletActiveClass: 'slider-pagination-bullet--active',
      currentClass: 'slider-pagination--current',
      hiddenClass: 'slider-pagination--hidden',
      clickable: true,
    },
    navigation: {
      nextEl: $(this).find('.slider-icons--next'),
      prevEl: $(this).find('.slider-icons--prev'),
    },
  };

  var textSlider = new Swiper($(this).find('.text-slider'), sliderConfig);
});

$('.cards-slider').each(function () {
  $(this).append('<i class="slider-icons slider-icons--prev"></i><i class="slider-icons slider-icons--next"></i>');
});

$('[data-type="slider"]').each(function () {
  var $this = $(this);
  var thisType = $this.data('type');
  var sliderName = $this.data('slider-name');

  if (thisType == 'slider') {
    switch (sliderName) {
      case 'hero-slider':
        var sliderConfig = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          speed: 350,
          containerModifierClass: 'hero-slider--',
          wrapperClass: 'hero-wrapper',
          slideClass: 'hero-slide',
          slideActiveClass: 'hero-slide--active',
          slideNextClass: 'hero-slide--next',
          slidePrevClass: 'hero-slide--prev',
          pagination: {
            el: '.hero-slider .slider-pagination',
            bulletClass: 'slider-pagination-bullet',
            bulletActiveClass: 'slider-pagination-bullet--active',
            currentClass: 'slider-pagination--current',
            hiddenClass: 'slider-pagination--hidden',
            clickable: true,
          },
          navigation: {
            nextEl: '.hero-slider > .controls-next',
            prevEl: '.hero-slider > .controls-prev',
          },
        };

        break;

      case 'cards-slider':
        var sliderLength = $(this).find('.cards-wrapper > *').length;

        if (sliderLength == 1) {
          $(this).addClass('one-slide');
        }

        var sliderConfig = {
          slidesPerView: 1,
          spaceBetween: 15,
          loop: sliderLength != 1,
          containerModifierClass: 'cards-slider--',
          wrapperClass: 'cards-wrapper',
          slideClass: 'cards-slide',
          slideActiveClass: 'cards-slide--active',
          slideNextClass: 'cards-slide--next',
          slidePrevClass: 'cards-slide--prev',
          pagination: {
            el: '.cards-slider .slider-pagination--relative',
            bulletClass: 'slider-pagination-bullet--dark',
            bulletActiveClass: 'slider-pagination-bullet--active',
            currentClass: 'slider-pagination-bullet--current',
            hiddenClass: 'slider-pagination-bullet--hidden',
            clickable: true,
          },
          navigation: {
            prevEl: $this.find('.slider-icons--prev'),
            nextEl: $this.find('.slider-icons.slider-icons--next'),
          },
          breakpoints: {
            767.99: {
              slidesPerView: sliderLength != 1 ? 3 : 1,
              spaceBetween: 10,
              centeredSlides: sliderLength == 1,
            },
          },
          lazy: {
            elementClass: 'lazy',
            loadPrevNext: true,
            loadedClass: 'lazy-loaded',
          },
        };

        break;
    }

    slidersArray.push(new Swiper($this[0], sliderConfig));
  }
});

document.addEventListener('DOMContentLoaded', function () {
  fakeInputsInit();

  setHeaderHeight();
  animatedHeaderInit();

  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('orientationchange', setHeaderHeight);

  onePerViewSlidersInit();
  heroSliderV2Init();
  freeModeSliderInit();
  roomsSliderInit();

  setVH();

  $('.hero-slide .image').each(function () {
    var ww = $(window).width();
    setHeroSlideAR(ww);
  });
});

// window.addEventListener('DOMContentLoaded', function () {
//   var body = document.querySelector('body');

//   $('#googlemap').each(function () {
//     initFWMap('googlemap');
//   });
// });

$(window).on({
  load: function () {
    $('[data-toggle=popover]').popover();
    setCardsSlider();

    $(document).on('click', '.js-btnCallYouTrigger', function () {
      $('#callYouModal').modal('show');
    });
  },
  resize: function () {
    setCardsSlider();

    if (arrayOfSliders.length != 0)
      arrayOfSliders.forEach(function (e) {
        e.update(true);
      });

    $('.hero-slide .image').each(function () {
      var ww = $(window).width();
      setHeroSlideAR(ww);
    });
  },
  oriantedChange: function () {
    if (arrayOfSliders.length != 0)
      arrayOfSliders.forEach(function (e) {
        e.update(true);
      });
  },
});

$('[slider-only-mobile]').each(function () {
  var ww = $(window).outerWidth();
  var $this = $(this);
  var sliderName = $this.data('slider-name');
  var sliders = [];

  if (ww < 768) {
    switch (sliderName) {
      case 'videoSlider':
        var config = {
          slidesPerView: 1.6805,
          spaceBetween: 10,
          containerModifierClass: 'video-section__slider--',
          wrapperClass: 'video-wrapper',
          slideClass: 'video-slide',
          slideActiveClass: 'video-slide--active',
          slideNextClass: 'video-slide--next',
          slidePrevClass: 'video-slide--prev',
          preventLinks: true,
          residence: '100%',
          freeMode: true,
        };

        sliders.push(new Swiper($this, config));
        break;
    }
  }
});

$('.hero-slider').each(function () {
  var $this = $(this);
  var thisSwiper = $this[0].swiper;

  $('.controls-next').on({
    mouseenter: function () {
      var thisIndex = thisSwiper.activeIndex;
      $(thisSwiper.slides[thisIndex + 1]).toggleClass('next-transform');
    },
    mouseleave: function () {
      var thisIndex = thisSwiper.activeIndex;

      if ($(thisSwiper.slides[thisIndex + 1]).hasClass('next-transform')) $(thisSwiper.slides[thisIndex + 1]).removeClass('next-transform');
    },
    click: function () {
      $('.hero-slide').removeClass('next-transform');
    },
  });

  $('.controls-prev').on({
    mouseenter: function () {
      var thisIndex = thisSwiper.activeIndex;
      $(thisSwiper.slides[thisIndex - 1]).addClass('prev-transform');
    },
    mouseleave: function () {
      var thisIndex = thisSwiper.activeIndex;

      if ($(thisSwiper.slides[thisIndex - 1]).hasClass('prev-transform')) $(thisSwiper.slides[thisIndex - 1]).removeClass('prev-transform');
    },
    click: function () {
      $('.hero-slide').removeClass('prev-transform');
    },
  });
});

$('.mouse-icon').on('click', function () {
  $('html,body').animate(
    {
      scrollTop: $(this).closest('section').siblings('section').offset().top,
    },
    1000,
  );
});

$('.type--slider').each(function () {
  var $this = $(this);

  $this.append("<div class='slider-pagination'></div>");

  var config = {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    effect: 'fade',
    containerModifierClass: 'image-blurred-block--',
    wrapperClass: 'image-blurred-wrapper',
    slideClass: 'image-blurred-contents',
    slideActiveClass: 'image-blurred-contents--active',
    slideNextClass: 'image-blurred-contents--next',
    slidePrevClass: 'image-blurred-contents--prev',
    pagination: {
      el: this.querySelector('[class*=slider-pagination]'),
      bulletClass: 'slider-pagination-bullet',
      bulletActiveClass: 'slider-pagination-bullet--active',
      currentClass: 'slider-pagination-bullet--current',
      hiddenClass: 'slider-pagination-bullet--hidden',
      clickable: true,
    },
    lazy: {
      elementClass: 'lazy',
      loadPrevNext: true,
      loadedClass: 'lazy-loaded',
    },
  };

  var slider = new Swiper($this, config);
});

$('.grid').each(function () {
  var ww = $(window).outerWidth();

  function gridInit(windowWidth) {
    $('.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      horizontalOrder: windowWidth >= 1280 ? false : true,
    });
  }

  gridInit(ww);

  $(window).on('resize', function () {
    ww = $(window).outerWidth();

    gridInit(ww);
  });
});

$('.bordered-cards-list').each(function () {
  var $this = $(this);
  var ww = $(window).outerWidth();

  var showBorderedCards = function (ev) {
    if (ev == 'show') {
      $('.bordered-cards-list > .bordered-cards:hidden').slice(0, 2).addClass('is-shown');
    } else {
      $('.bordered-cards-list > .bordered-cards').removeClass('is-shown');
      $('.bordered-cards-list > .bordered-cards').slice(0, 2).addClass('is-shown');
    }
  };

  showBorderedCards('show');

  $('.btn--more').on('click', function () {
    var hiddenCount = $('.bordered-cards-list > .bordered-cards:hidden').length;

    if (hiddenCount != 0) {
      showBorderedCards('show');
    } else {
      showBorderedCards('hide');
    }

    hiddenCount = $('.bordered-cards-list > .bordered-cards:hidden').length;

    if (hiddenCount != 0) {
      $(this).text('Show More');
      $(this).removeClass('minus-icon');
    } else {
      $(this).text('Show Less');
      $(this).addClass('minus-icon');
    }
  });
});

$('.gallery-grid').each(function () {
  var isSquare = $(this).hasClass('square');

  $('.gallery-grid').masonry({
    itemSelector: isSquare ? '.gallery-grid-item--square' : '.gallery-grid-item',
    columnWidth: '.gallery-grid-sizer',
    percentPosition: true,
  });
});

$('section.main-headings').each(function () {
  $(this).next().addClass('main-headings-siblings');
});

$('.image-content-wrapper').each(function () {
  var $hiddenInput = $(this).find('input[type="hidden"]');
  var $hiddenLinks = $(this).find('a[hidden-link]');

  $hiddenLinks.attr('href', $hiddenInput.val());
});

$('.grid-cards-wrapper').each(function () {
  $(this).masonry({
    itemSelector: '.grid-cards-item',
    columnWidth: '.grid-cards-sizer',
    gutter: '.gutter-sizer',
    percentPosition: true,
  });
});

$('[class*=gallery] a[class*=-link]').on('click', function (e) {
  e.preventDefault();

  var imgTag = $(this).closest('section').find('img');

  var imgListSources = [];
  var imgListAltTexts = [];

  var imgsLists = $(this).data("imgs");
  var galleryTitle = $(this).data("gallery-title");
  $("[class*=gallery] h5[class*=-title]").text(galleryTitle);
  if (imgsLists === undefined) {
      var imgs = $(this).closest('section').find('img');

      imgs.each(function (index) {
          var slideWithImg = `<div class="gallery-slider-slide"><figure class="image"><img class="lazy" data-src="${$(this).attr('src')}" /></figure></div>`;
          $('.gallery-slider--main > .gallery-slider-wrapper').append(slideWithImg);
      });

      imgs.each(function (index) {
          var slideWithImg = `<div class="gallery-slider-slide"><figure class="image"><img class="lazy" data-src="${$(this).attr('src')}" /></figure></div>`;
          $('.gallery-slider--thumbs > .gallery-slider-wrapper').append(slideWithImg);
      });   
  }
  else {
      $.each(imgsLists, function (e, imgTag) {
          imgListAltTexts.push(imgTag.AltText);
      });
      $.each(imgsLists, function (e, imgTag) {
          imgListSources.push(imgTag.Path);
      });

      imgListSources.forEach(function (e) {
          var slideWithImg = `<div class="gallery-slider-slide"><figure class="image"><img class="lazy" data-src="${e}" /></figure>\n    <p style="text-align:center; margin-top:20px">${imgListAltTexts[imgListSources.indexOf(e)]} <p></div>`;
          $(".gallery-slider--main > .gallery-slider-wrapper").append(slideWithImg);
      });

      imgListSources.forEach(function (e) {
          var slideWithImg = `<div class="gallery-slider-slide"><figure class="image"><img class="lazy" data-src="${e}" /></figure></div>`;
          $(".gallery-slider--thumbs > .gallery-slider-wrapper").append(slideWithImg);
      });
  }
  $('#galleryModal').modal('toggle', $(this));
});

$('#galleryModal').on('shown.bs.modal', function (e) {
  var gallerySliderThumbs = [];
  var galleryMainSlider = [];
  var loopedSlides = $('.gallery-slider--main > .gallery-slider-wrapper > .gallery-slider-slide').length;

  var idx = $(e.relatedTarget).parent().index();

  gallerySliderThumbs = new Swiper('.gallery-slider.gallery-slider--thumbs', {
    containerModifierClass: 'gallery-slider--',
    wrapperClass: 'gallery-slider-wrapper',
    slideClass: 'gallery-slider-slide',
    slideActiveClass: 'gallery-slider-slide--active',
    slideNextClass: 'gallery-slider-slide--next',
    slidePrevClass: 'gallery-slider-slide--prev',
    slidesPerView: 3,
    spaceBetween: 5,
    // freeMode: true,
    loop: true,
    loopedSlides: loopedSlides,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    lazy: {
      elementClass: 'lazy',
      loadPrevNext: true,
      loadedClass: 'lazy-loaded',
    },
    breakpoints: {
      1279: {
        spaceBetween: 10,
        slidesPerView: 6,
      },
    },
  });

  galleryMainSlider = new Swiper('.gallery-slider.gallery-slider--main', {
    containerModifierClass: 'gallery-slider--',
    wrapperClass: 'gallery-slider-wrapper',
    slideClass: 'gallery-slider-slide',
    slideActiveClass: 'gallery-slider-slide--active',
    slideNextClass: 'gallery-slider-slide--next',
    slidePrevClass: 'gallery-slider-slide--prev',
    spaceBetween: 10,
    loop: true,
    loopedSlides: loopedSlides,
    navigation: {
      nextEl: '.slider-icons--next.main-slider',
      prevEl: '.slider-icons--prev.main-slider',
    },
    thumbs: {
      swiper: gallerySliderThumbs,
      slideThumbActiveClass: 'gallery-slider-slide-thumbs--active',
    },
    lazy: {
      elementClass: 'lazy',
      loadPrevNext: true,
      loadedClass: 'lazy-loaded',
    },
  });

  galleryMainSlider.slideTo(idx);
});

$('#galleryModal').on('hidden.bs.modal', function (e) {
  $(this).find('.gallery-slider-wrapper').empty();

  $(this)
    .find('.gallery-slider')
    .each(function (i, e) {
      $(this)[0].swiper.destroy();
    });
});

// document.addEventListener('DOMContentLoaded', function() {
//   var imgList = [
//     'http://via.placeholder.com/946x531',
//     'http://via.placeholder.com/946x531',
//     'http://via.placeholder.com/946x531',
//     'http://via.placeholder.com/946x531',
//     'http://via.placeholder.com/946x531',
//     'http://via.placeholder.com/946x531',
//     'http://via.placeholder.com/946x531',
//     'http://via.placeholder.com/946x531',
//   ];

//   var imgThumbList = [
//     'http://via.placeholder.com/112x88',
//     'http://via.placeholder.com/112x88',
//     'http://via.placeholder.com/112x88',
//     'http://via.placeholder.com/112x88',
//     'http://via.placeholder.com/112x88',
//     'http://via.placeholder.com/112x88',
//     'http://via.placeholder.com/112x88',
//     'http://via.placeholder.com/112x88',
//   ];

//   imgList.forEach(function(e) {
//     var slideWithImg = `<div class="gallery-slider-slide"><figure class="image"><img class="lazy" data-src="${e}" /></figure></div>`;
//     $('.gallery-slider--main > .gallery-slider-wrapper').append(slideWithImg);
//   });

//   imgThumbList.forEach(function(e) {
//     var slideWithImg = `<div class="gallery-slider-slide"><figure class="image"><img class="lazy" data-src="${e}" /></figure></div>`;
//     $('.gallery-slider--thumbs > .gallery-slider-wrapper').append(slideWithImg);
//   });
// });

$(window).on('load', function () {
  $('#galleryModal').each(function () {
    // var gallerySliderThumbs = [];
    // var galleryMainSlider = [];
    // var loopedSlides = $('.gallery-slider--main > .gallery-slider-wrapper > .gallery-slider-slide').length;
    // gallerySliderThumbs = new Swiper('.gallery-slider.gallery-slider--thumbs', {
    //   containerModifierClass: 'gallery-slider--',
    //   wrapperClass: 'gallery-slider-wrapper',
    //   slideClass: 'gallery-slider-slide',
    //   slideActiveClass: 'gallery-slider-slide--active',
    //   slideNextClass: 'gallery-slider-slide--next',
    //   slidePrevClass: 'gallery-slider-slide--prev',
    //   slidesPerView: 3,
    //   spaceBetween: 5,
    //   loop: true,
    //   freeMode: true,
    //   loopedSlides: loopedSlides, //looped slides should be the same
    //   watchSlidesVisibility: true,
    //   watchSlidesProgress: true,
    //   touchRatio: 0.2,
    //   slideToClickedSlide: true,
    //   lazy: {
    //     elementClass: 'lazy',
    //     loadPrevNext: true,
    //     loadedClass: 'lazy-loaded',
    //   },
    //   breakpoints: {
    //     1279: {
    //       spaceBetween: 10,
    //       slidesPerView: 6,
    //     },
    //   },
    // });
    // galleryMainSlider = new Swiper('.gallery-slider.gallery-slider--main', {
    //   containerModifierClass: 'gallery-slider--',
    //   wrapperClass: 'gallery-slider-wrapper',
    //   slideClass: 'gallery-slider-slide',
    //   slideActiveClass: 'gallery-slider-slide--active',
    //   slideNextClass: 'gallery-slider-slide--next',
    //   slidePrevClass: 'gallery-slider-slide--prev',
    //   spaceBetween: 10,
    //   loop: true,
    //   loopedSlides: loopedSlides,
    //   navigation: {
    //     nextEl: '.slider-icons--next.main-slider',
    //     prevEl: '.slider-icons--prev.main-slider',
    //   },
    //   thumbs: {
    //     swiper: gallerySliderThumbs,
    //     slideThumbActiveClass: 'gallery-slider-slide-thumbs--active',
    //   },
    //   lazy: {
    //     elementClass: 'lazy',
    //     loadPrevNext: true,
    //     loadedClass: 'lazy-loaded',
    //   },
    // });
  });
});

$('.js-yt-div').each(function () {
  var thisVideoSource = $(this).attr('video-source');
  var jsClasses = $(this).attr('js-class');
  var id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  var videoImages =`
  <a class="yt-link${jsClasses ? ' ' + jsClasses : ' js-yt-link'}">
    <figure class="image">
      <picture>
        <source media="(min-width: 1280px)" srcset="https://img.youtube.com/vi/${thisVideoSource}/maxresdefault.jpg">
        <source media="(min-width: 768px)" srcset="https://img.youtube.com/vi/${thisVideoSource}/sddefault.jpg">
        <img class="lazy" loading="lazy" data-src="https://img.youtube.com/vi/${thisVideoSource}/hqdefault.jpg" />
      </picture>
      <div id="yt-${id}" class="iframe"></div>
    </figure>
  </a>
  `;

  $(this).append(videoImages);
});

$('.yt-slider').each(function () {
  var sliderConfig = {
    slidesPerView: 1.5526,
    spaceBetween: 9,
    containerModifierClass: 'yt-slider--',
    wrapperClass: 'yt-wrapper',
    slideClass: 'yt-slide',
    slideActiveClass: 'yt-slide--active',
    slideNextClass: 'yt-slide--next',
    slidePrevClass: 'yt-slide--prev',
    breakpoints: {
      768: {
        direction: 'vertical',
        slidesPerView: 2,
        loop: false,
        spaceBetween: 9,
      },
      1280: {
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 0,
        loop: false,
      },
    },
  };

  var slider = new Swiper('.yt-slider', sliderConfig);
});

var player = [];
window.addEventListener('DOMContentLoaded',function(){
  var tag = document.createElement('script');
  tag.defer = true;
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
});
function onYouTubeIframeAPIReady() {
  window.dispatchEvent(new Event('YouTubeIframeAPIReady'))
  
  $('.js-yt-link').each(function (idx) {
    var ww = $(window).outerWidth();
    var id = $(this).find('.iframe').attr('id');
    var videoSource = $(this).parent().attr('video-source');

    if (ww < 768) {
      player[idx] = new YT.Player(id, {
        videoId: videoSource,
      });
    } else {
      $(this)
        .closest('.yt-main')
        .each(function () {
          player = new YT.Player(id, {
            videoId: videoSource,
          });
        });
    }
  });
};

function playYouTubeVideoOnMobile(id) {
  for (let i = 0; i < player.length; i++) {
    player[i].stopVideo();
    if ($(player[i].f).attr('id') == id) {
      player[i].playVideo();
    }
  }
}

function playYouTubeVideo(videoSource) {
  player.stopVideo();
  player.loadVideoById(videoSource);

  setTimeout(function () {
    player.playVideo();
  }, 250);
}

$('.js-yt-link').on('click', function (e) {
  e.preventDefault();

  var id = $(this).find('iframe').attr('id');
  var ww = $(window).outerWidth();
  var videoSource = $(this).parent().attr('video-source');
  var cssClass = 'is-playing';

  $('.js-yt-link').removeClass(cssClass);

  if (ww < 768) {
    $(this).addClass(cssClass);
    playYouTubeVideoOnMobile(id);
  } else {
    $('.yt-main .js-yt-link').addClass(cssClass);
    playYouTubeVideo(videoSource);
  }
  /*  */
  
  // console.debug(this)
  // console.debug(id, ww, videoSource, cssClass, player)
  /*  */
});

const loadMap =()=>{
  let mapDiv=document.querySelectorAll('.hotel-cards-slider, .slider--free-mode')[0];
 if(mapDiv && mapDiv.getBoundingClientRect().top<=window.innerHeight)
 {
   var script=document.createElement('script');
   script.src=`https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3A942f1dc6c18308a5ec51eee7f7ff47929d8d778a6c3a9618f22a0a277aa2bd36&amp;width=1080&amp;height=520&amp;lang=tr_TR&amp;scroll=true&id=yandexmap`;
   script.type='text/javascript';
   script.charset='utf-8';
   var firstScript=document.getElementsByTagName('script')[0];
   if(firstScript && firstScript.parentNode){
  firstScript.parentNode.insertBefore(script,firstScript);
   }
   document.removeEventListener('scroll',loadMap);
 }
}
// document.addEventListener('scroll',loadMap);